import { render, staticRenderFns } from "./CaseTaskSelect.vue?vue&type=template&id=a3bdc654"
import script from "./CaseTaskSelect.vue?vue&type=script&lang=js"
export * from "./CaseTaskSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports